import { render, staticRenderFns } from "./UserPickerModal.vue?vue&type=template&id=66a691bc"
import script from "./UserPickerModal.vue?vue&type=script&lang=js"
export * from "./UserPickerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66a691bc')) {
      api.createRecord('66a691bc', component.options)
    } else {
      api.reload('66a691bc', component.options)
    }
    module.hot.accept("./UserPickerModal.vue?vue&type=template&id=66a691bc", function () {
      api.rerender('66a691bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/UserPickerModal.vue"
export default component.exports